import axios from '@/server/axios'


export function queryBanner() {
  return axios({
    url: 'officialWebsite/queryBanner.do',
    method: 'get',
    params: {

    }
  })
}